import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"
import { Store, getTokenLocal } from "../helper/utils"

export default class AdminAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // token = getTokenLocal();

  adminInfo = ApiRoutes.Admin.AdminInfo
  allAdvisors = ApiRoutes.Admin.AllAdvisors
  allCsm = ApiRoutes.Admin.AllCsm
  allGa = ApiRoutes.Admin.AllGa
  allOfficeManagers = ApiRoutes.Admin.AllOfficeManagers

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  getAdminInfo = (token: string) => {
    return this.instance({
      method: this.adminInfo.Method,
      url: this.adminInfo.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getAllGa = (token: string, groupSk: string) => {
    return this.instance({
      method: this.allGa.Method,
      url: this.allGa.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getAllAdvisors = (token: string, groupSk: string) => {
    return this.instance({
      method: this.allAdvisors.Method,
      url: this.allAdvisors.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getAllCsm = (token: string, groupSk: string) => {
    return this.instance({
      method: this.allCsm.Method,
      url: this.allCsm.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }
  getOfficeManagers = (token: string, groupSk: string) => {
    return this.instance({
      method: this.allOfficeManagers.Method,
      url: this.allOfficeManagers.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }
}
